import { UserContext } from "context/ViewContext/UserContext";
import { useContext } from "react";
import { selectActingCompany } from "./useUser";

export const useCompany = () => {
  const { user } = useContext(UserContext);
  return user?.currentCompany || selectActingCompany(user);
};
